import { useParams } from "wouter";
import QuoteAIPage from "./quote-ai";

/** Editing is the Auto Quote workspace, not a second implementation. */
export default function QuoteEditPage() {
  const { id } = useParams<{ id: string }>();
  return <QuoteAIPage key={id} editingQuoteId={id} />;
}
